import {createContext, ReactNode} from "react";

import useFetchVerifiedAssets from "../util/useFetchVerifiedAssets";
import {VerifiedAssets} from "../../util/assetModels";

const VerifiedAssetsContext = createContext<VerifiedAssets | null>(null);

VerifiedAssetsContext.displayName = "VerifiedAssetContext";

interface VerifiedAssetsContextProviderProps {
  children: ReactNode;
}

function VerifiedAssetsContextProvider({children}: VerifiedAssetsContextProviderProps) {
  const verifiedAssets = useFetchVerifiedAssets();

  return (
    <VerifiedAssetsContext.Provider value={verifiedAssets}>
      {children}
    </VerifiedAssetsContext.Provider>
  );
}

export default VerifiedAssetsContext;
export {VerifiedAssetsContextProvider};
